export function distinctByProp<T>(array: T[], prop: keyof T) {
  return array.filter((x, i, arr) => arr.findIndex((y) => y[prop] === x[prop]) === i);
}

export const isArray = (a) => Array.isArray(a);
